import { Calendar, Briefcase, Sparkles, BarChart3 } from 'lucide-react';
import { LandingTemplate, type LandingData } from '../components/LandingTemplate';
import { LANDING_GUIDES } from '../lib/landingGuides';

const data: LandingData = {
  seo: {
    title: 'Cómo programar publicaciones en LinkedIn, paso a paso · Zettapost',
    description:
      'Cómo programar publicaciones en LinkedIn desde la propia red y con Zettapost, en tu perfil y en tus páginas de empresa. Prueba 3 días gratis.',
    canonical: 'https://zettapost.com/programar-linkedin',
  },
  hero: {
    eyebrow: 'Programar LinkedIn',
    headlinePre: 'Programa LinkedIn',
    headlineAccent: 'sin perder el tono profesional.',
    subhead:
      'Programa posts, vídeos y carruseles en tus perfiles y páginas de empresa. Sin recordatorios, sin abrir LinkedIn 5 veces al día, con métricas reales para saber qué te trae mejor red.',
    bullets: [
      'Perfil personal y página de empresa',
      'Posts, vídeo y carruseles',
      'IA en tono profesional',
      '3 días gratis',
    ],
  },
  why: {
    eyebrow: '¿Por qué Zettapost para LinkedIn?',
    title: 'Construye tu marca personal sin vivir en LinkedIn.',
    subtitle:
      'Pensado para fundadores, freelancers, vendedores, agencias y marcas que quieren posicionarse en LinkedIn sin pasar el día allí.',
    items: [
      {
        Icon: Calendar,
        title: 'Programa a las mejores horas',
        description:
          'Publica en las franjas con más engagement (mañana entre semana y miércoles al mediodía). Zettapost lo lanza solo, también los días no laborables si quieres.',
      },
      {
        Icon: Briefcase,
        title: 'Perfil y página de empresa',
        description:
          'Gestiona tu cuenta personal y las páginas de empresa que administres desde el mismo panel. Ideal para fundadores y equipos pequeños.',
      },
      {
        Icon: Sparkles,
        title: 'IA en tono LinkedIn',
        description:
          'La IA escribe tus posts con el tono que esperan en LinkedIn — directo, útil, con gancho — adaptado a tu nicho y a tu marca personal.',
      },
      {
        Icon: BarChart3,
        title: 'Mide qué te trae red',
        description:
          'Impresiones, reacciones, comentarios y clics de cada publicación. Identifica qué temas te abren puertas y replícalos.',
      },
    ],
  },
  guide: LANDING_GUIDES.linkedin,
  faqs: [
    {
      q: '¿Puedo programar en mi perfil personal y en páginas de empresa?',
      a: 'Sí. Conectas tu cuenta de LinkedIn una sola vez y desde ahí publicas tanto en tu perfil personal como en cualquier página de empresa que administres. Las cambias con un selector al crear el post.',
    },
    {
      q: '¿Soporta vídeo y carruseles (PDF)?',
      a: 'Sí. Soportamos imagen, vídeo y documento PDF (los carruseles nativos de LinkedIn se publican como PDF con varias páginas). Adjuntas el archivo y se publica con su preview correcto.',
    },
    {
      q: '¿Funciona con la API oficial de LinkedIn?',
      a: 'Sí. Conectamos vía LinkedIn Marketing API oficial. Esto significa que tus publicaciones se publican exactamente igual que si las hicieras desde la app, sin penalización en el alcance.',
    },
    {
      q: '¿Puedo programar artículos largos?',
      a: 'Los artículos largos de LinkedIn (los que aparecen en Pulse) se siguen creando desde LinkedIn. Lo que sí programas desde Zettapost son los posts y los enlaces a esos artículos, que es lo que mueve el alcance.',
    },
    {
      q: '¿Cuántas cuentas de LinkedIn puedo conectar?',
      a: 'Depende del plan. Los planes para marcas y agencias permiten conectar varios perfiles personales y páginas de empresa en paralelo y separarlos por marca.',
    },
    {
      q: '¿Puedo etiquetar a personas o empresas?',
      a: 'Sí, igual que en LinkedIn nativo. Al escribir @nombre, la app muestra sugerencias y se etiqueta correctamente en el post programado.',
    },
  ],
  finalCta: {
    title: 'Programa LinkedIn',
    titleAccent: 'mientras tomas un café.',
    description: 'Crea tu cuenta y conecta LinkedIn gratis durante 3 días.',
  },
  related: [
    { to: '/programar-x', label: 'Programar X' },
    { to: '/programar-instagram', label: 'Programar Instagram' },
    { to: '/precios', label: 'Ver precios' },
    { to: '/blog', label: 'Blog' },
  ],
};

export function ProgramarLinkedin() {
  return <LandingTemplate data={data} />;
}
